// extracted by mini-css-extract-plugin
export default {"shareIcon":"shareIcon___tcwXj"};